import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CurrentUserService } from 'src/app/services/current-user.service';
import { DataService } from 'src/app/services/data.service';
import { MapService } from 'src/app/services/map.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-create-game-map-selection-modal',
    templateUrl: './create-game-map-selection-modal.component.html',
    styleUrls: ['./create-game-map-selection-modal.component.scss'],
    standalone: false
})
export class CreateGameMapSelectionModalComponent implements OnInit {

  user_id: any
  selectedMap_id: any
  mapList: any
  mapListSubscription: Subscription;

  constructor(
    private mapListService: DataService,
    private currentUserService: CurrentUserService,
    private router: Router,
    private activeModal: NgbActiveModal,
    private mapService: MapService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.currentUserService.currentUser.subscribe((data) => {
      if (data) {
        this.user_id = data.id
        this.getmaplist();
        this.cdr.detectChanges();
      }
    })
    this.mapListSubscription = this.mapService.mapList$.subscribe((data: any) => {
      if (data) {
        this.mapList = [...data].sort((a: any, b: any) => {
          const aDefault = !!a.is_default;
          const bDefault = !!b.is_default;
          if (aDefault !== bDefault) {
            return aDefault ? -1 : 1;
          }
          const aName = (a.map_name || '').toLowerCase();
          const bName = (b.map_name || '').toLowerCase();
          return aName.localeCompare(bName);
        });
        if (this.mapList.length > 0 && !this.selectedMap_id) {
          this.selectedMap_id = this.mapList[0].map_id;
        }
      }
      else {
        this.mapService.getMapList();
      }
      this.cdr.detectChanges();
    });
  }


  onMapSelection(event) {

    this.selectedMap_id = event.target.value
  }

  getmaplist() {
    this.mapService.getMapList(this.user_id, false);
  }

  selectMap() {
    this.activeModal.close()
    const selectedMap = this.mapList.find((map: any) => map.map_id === this.selectedMap_id);
    this.router.navigate(['/creategame-mapview', this.selectedMap_id, selectedMap.map_name, 'activegames', selectedMap.map_genre || 'Unknown']);
  }

  closeModal() {
    this.activeModal.close();
  }

}
